// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {putDealerInvoices} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateDealerInvoices = invoice =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await putDealerInvoices(invoice);

            successAlertBar(translate('INVOICE_UPDATED_SUCCESSFULLY'));

            dispatch(routerActions.push('/claims/dealer-invoices'));

            dispatch({
                type: actions.RESET_DEALER_INVOICE_INVOICE_TO_COMPLETE
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/action-creators/put-dealer-invoice.js